import { useState } from "react";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import { adminList } from "@/lib/api";
import { fmt } from "@/data/pricing";

export default function Admin() {
  const [key, setKey] = useState("");
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("leads");

  const load = async (e) => {
    e.preventDefault();
    try {
      const [leads, bookings] = await Promise.all([adminList("leads", key), adminList("bookings", key)]);
      setData({ leads, bookings });
    } catch { toast.error("Invalid admin key"); }
  };

  return (
    <main className="min-h-screen bg-linen px-5 sm:px-8 lg:px-16 py-10" data-testid="admin-page">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between"><Logo /><a href="/" className="text-sm text-stone hover:text-brass" data-testid="admin-home-link">← Back to site</a></div>
        {!data ? (
          <form onSubmit={load} className="mt-16 max-w-sm bg-white border border-line p-8" data-testid="admin-login-form">
            <h1 className="font-serif text-3xl text-ink">Enquiries</h1>
            <label className="label mt-6" htmlFor="admin-key">Admin key</label>
            <input id="admin-key" type="password" className="field" value={key} onChange={(e) => setKey(e.target.value)} data-testid="admin-key-input" />
            <button className="btn-ink w-full mt-4" data-testid="admin-login-btn">View enquiries</button>
          </form>
        ) : (
          <div className="mt-12">
            <div className="flex gap-2 mb-8">
              {["leads", "bookings"].map((t) => <button key={t} onClick={() => setTab(t)} className={`h-10 px-5 text-sm border capitalize ${tab === t ? "bg-ink text-linen border-ink" : "border-line text-stone"}`} data-testid={`admin-tab-${t}`}>{t} ({data[t].length})</button>)}
            </div>
            <div className="overflow-x-auto bg-white border border-line">
              <table className="w-full text-sm" data-testid={`admin-table-${tab}`}>
                <thead className="bg-linen-2 text-left text-xs font-mono uppercase tracking-wider text-stone">
                  <tr>{(tab === "leads" ? ["When", "Name", "Contact", "Suburb", "Spec", "Estimate"] : ["When", "Name", "Contact", "Address", "Preferred", "Notes"]).map((h) => <th key={h} className="px-4 py-3">{h}</th>)}</tr>
                </thead>
                <tbody>
                  {data[tab].map((r) => (
                    <tr key={r.id} className="border-t border-line align-top">
                      <td className="px-4 py-3 whitespace-nowrap text-stone">{new Date(r.created_at).toLocaleString("en-AU")}</td>
                      <td className="px-4 py-3 font-medium">{r.full_name}</td>
                      <td className="px-4 py-3">{r.phone}<br /><span className="text-stone">{r.email}</span></td>
                      {tab === "leads" ? (<>
                        <td className="px-4 py-3">{r.suburb_postcode}</td>
                        <td className="px-4 py-3 text-stone">{r.estimate.product} · {r.estimate.style} · {r.estimate.hardware}<br />{r.estimate.tier} · {r.estimate.function} · {r.estimate.windows}× {r.estimate.size}<br />{r.estimate.addons.join(", ") || "No add-ons"}</td>
                        <td className="px-4 py-3 whitespace-nowrap font-mono text-brass">{fmt(r.estimate.low)} – {fmt(r.estimate.high)}</td>
                      </>) : (<>
                        <td className="px-4 py-3">{r.address}</td>
                        <td className="px-4 py-3 whitespace-nowrap">{r.preferred_date}<br /><span className="text-stone">{r.time_slot}</span></td>
                        <td className="px-4 py-3 text-stone">{r.notes || "—"}</td>
                      </>)}
                    </tr>
                  ))}
                  {!data[tab].length && <tr><td colSpan={6} className="px-4 py-10 text-center text-stone">No {tab} yet.</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </main>
  );
}
